export var ColumnAlignment;
(function (ColumnAlignment) {
    ColumnAlignment[ColumnAlignment["Left"] = 0] = "Left";
    ColumnAlignment[ColumnAlignment["Center"] = 1] = "Center";
    ColumnAlignment[ColumnAlignment["Right"] = 2] = "Right";
})(ColumnAlignment || (ColumnAlignment = {}));
export var ColumnColoringMode;
(function (ColumnColoringMode) {
    ColumnColoringMode[ColumnColoringMode["None"] = 0] = "None";
    ColumnColoringMode[ColumnColoringMode["Previous"] = 1] = "Previous";
    ColumnColoringMode[ColumnColoringMode["Signed"] = 2] = "Signed";
})(ColumnColoringMode || (ColumnColoringMode = {}));
export var ColumnTotalVisibility;
(function (ColumnTotalVisibility) {
    ColumnTotalVisibility[ColumnTotalVisibility["None"] = 0] = "None";
    ColumnTotalVisibility[ColumnTotalVisibility["Groups"] = 1] = "Groups";
    ColumnTotalVisibility[ColumnTotalVisibility["Overall"] = 2] = "Overall";
    ColumnTotalVisibility[ColumnTotalVisibility["All"] = 3] = "All";
})(ColumnTotalVisibility || (ColumnTotalVisibility = {}));
